import { TextareaHTMLAttributes } from 'react';

import { TextAreaBlock, TextAreaProps } from './primitives/TextAreaBlock';
import { asBlockField } from './Input';

export const TextArea = asBlockField<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  TextAreaProps & React.RefAttributes<HTMLTextAreaElement>,
  string
>(TextAreaBlock);
